






































import { Component, Vue } from 'vue-property-decorator';
import GroupActivitySection from "@/components/groupType/index/GroupActivitySection.vue";
import { Getter } from 'vuex-class';
import { Ladder } from '@/common/interface/group_type';

@Component({
  components: {
    "group-activity-section": GroupActivitySection,
  }
})
export default class GroupDiscount extends Vue {
  @Getter('ladderGroupList')
  ladderGroupList!: Array<Ladder>
  @Getter('section')
  section!: any
  @Getter('mainTextColor')
  mainTextColor!: any

}
